import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnChanges {

  @Input('email') user_email: string = '';
  @Input() passwd_reset_code: string = '';
  @Output() close: EventEmitter<any> = new EventEmitter();

  user_passwd: string;
  user_passwd2: string;

  password_reset_error: boolean = false;
  password_reset_requested: boolean = false;
  passwords_equal: boolean = false;

  update_password_error: boolean = false;
  request_password_reset: boolean = false;

  constructor(public dataService: DataService) { }

  ngOnChanges(changes) {
    if(!!this.dataService.reset_params) {
      this.password_reset_requested = true;
      this.user_email = this.dataService.reset_params.email;
      this.passwd_reset_code = this.dataService.reset_params.token;
    }
  }

  hide_reset_form() {
    this.close.emit(true);
  }

  start_request_password_reset(email){
    let email_lw = email.toLowerCase();

    this.dataService.forgot_password(email_lw).subscribe(
      (subuser)=>{
        console.debug(subuser);
        this.password_reset_error = false;
        this.password_reset_requested = true;
        this.dataService.presentMessage('Er is een email gestuurd met instructies voor wachtwoord herstel.', 'success', 0);

      },
      (error)=>{
        console.error(error);
        this.password_reset_error = true;
        this.password_reset_requested = false;
        this.dataService.presentMessage('Het versturen van de email is helaas niet gelukt. Probeer het later nog eens.', 'error', 0);
      }
    )
  }

  passwordCheck(){
    if (this.user_passwd === this.user_passwd2) {
      this.passwords_equal = true;
    }
    else{
      this.passwords_equal = false;
    }
    return this.passwords_equal;
  }

  update_password(){
    let passwords_equal = this.passwordCheck();
    if(passwords_equal) {
      let reset_data = {email: this.user_email.toLowerCase(), token: this.passwd_reset_code, password: this.user_passwd}
      this.dataService.reset_password(reset_data).subscribe(
        (details) => {
          console.debug(details);
          this.password_reset_requested = false;
          this.dataService.presentMessage('Uw wachtwoord is aangepast. U kunt nu inloggen', 'succes', 0);
          this.dataService.reset_params = undefined;
          this.hide_reset_form();
          },
          (error) => {
            console.warn(error);
            this.dataService.presentMessage('Helaas was het reset token niet (meer) geldig.', 'error', 0);
            this.password_reset_requested = false;
            this.update_password_error = true;
          });
    }
    else {

    }
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/reset-password/reset-password.component.ts